import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvtv3e9xd7: FaireProductEntity = {
  token: "p_rvtv3e9xd7",
  type: "product",
  name: "Vanilla Cookie Calm - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/1b5b7f876c1c0223bebadaaffa30ad0a10b4ee2fe46da1c9268dc9c5d8f2fb9d.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nSkip the sugar, keep the treat. This soothing tea evokes the warm and fuzzy feeling of cookies fresh from the oven. Rooibos, chamomile, tulsi keep it caffeine-free and ultra calming, blended with superfoods cinnamon, vanilla bean and toasted coconut. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Drizzle with honey or maple syrup for a sweeter touch \n * Ice it: Steep it double strength and top with plenty of ice. Great with oat milk. \n * Cold-brew: Brew it overnight with cold water and add milk and honey. \n\n\nWhen to Steep:\n\n * As an afternoon treat without the sugar. \n * As a tea latte instead of your afternoon coffee. \n * When you are under stress. \n * When you are feeling under the weather. \n * As an after-dinner treat with honey. \n * To help wind-down before bed. \n\nCaffeine-free\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:40.245Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
